import { Pipe, PipeTransform } from '@angular/core';
import { format, fromUnixTime } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { EIO_DATE_UI_FORMAT_PIPE } from '../consts/localization.const';

@Pipe({
  standalone: true,
  name: 'dateepoch',
  pure: true
})
export class DatePipe implements PipeTransform {
  transform(epoch: number, timezone?: string, dateFormat?: string) {
    const userTimezone = timezone ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!epoch) {
      return;
    }
    return format(utcToZonedTime(fromUnixTime(epoch), userTimezone), dateFormat ?? EIO_DATE_UI_FORMAT_PIPE);
  }
}
